import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CursorsControl } from 'src/app/models/session';
import { SpaceSettingsUpdateService } from 'src/app/services/space-settings-update.service';

@Injectable({
  providedIn: 'root',
})
export class CursorControlsService {
  constructor(
    private translateService: TranslateService,
    private spaceSettingsUpdateService: SpaceSettingsUpdateService,
  ) {}

  public readonly CursorsControlOptions = {
    [CursorsControl.AUTOMATIC]: {
      label: this.translateService.instant('Automatic'),
      subtitle: this.translateService.instant('Host-only if 5+ people per board'),
    },
    [CursorsControl.ONLY_HOST]: {
      label: this.translateService.instant('Only host'),
      subtitle: this.translateService.instant('Only show host cursors'),
    },
    [CursorsControl.SHOW_ALL]: {
      label: this.translateService.instant('Show all'),
      subtitle: this.translateService.instant("Show everyone's cursors"),
    },
    [CursorsControl.HIDE_ALL]: {
      label: this.translateService.instant('Hide all'),
      subtitle: this.translateService.instant("Hide everyone's cursors"),
    },
  };

  applyChangeCursorsControl(value: CursorsControl) {
    this.spaceSettingsUpdateService.updateSettingsAndNotify({ cursorsControl: value });
  }
}
